import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=5b1bf681&scoped=true"
import script from "./Teacher.vue?vue&type=script&lang=js"
export * from "./Teacher.vue?vue&type=script&lang=js"
import style0 from "./Teacher.vue?vue&type=style&index=0&id=5b1bf681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1bf681",
  null
  
)

export default component.exports